import PropTypes from "prop-types"
import { useSelector } from 'react-redux'

import AddToCartButton from '@/components/PDP/PricingPanel/AddToCartButton'
import QuantityWithOptions from
  "@/components/VariantSelectorContainer/QuantityWithOptions"
import { isShowingQuantityInputOnPDPSelector } from '@/selectors'

const BulkStoreAddToCartButton = ({ translations }) => {
  const isShowing = useSelector(isShowingQuantityInputOnPDPSelector)
  const isBulkIntegrationEnabled = useSelector(
    state => state.featureFlags.bulkIntegrationEnabled
  )

  return (
    <div className='asset-action-bulk-enabled'>
      <If condition={!isBulkIntegrationEnabled && isShowing}>
        <QuantityWithOptions {...{ translations }} />
      </If>
      <AddToCartButton />
    </div>
  )
}

export default BulkStoreAddToCartButton

BulkStoreAddToCartButton.propTypes = {
  translations: PropTypes.shape({
    decrease_button: PropTypes.string,
    increase_button: PropTypes.string,
    quantity_label: PropTypes.string
  }).isRequired
}